window.MaissonDesign.register(({on,cleanup}) => {

const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const targets = '.mm-intro, .mm-product, .mm-story, .mm-steps > div, .product-editorial, .related > div > a, .mm-assurance, .mm-founder';
  function configureMotion() {
    observer?.disconnect();
    document.querySelectorAll('.mm-reveal-pending').forEach(element => element.classList.remove('mm-reveal-pending'));
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('mm-reveal-pending');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -25px 0px' });
    document.querySelectorAll(targets).forEach((element, index) => {
      element.classList.add('mm-reveal');
      element.style.setProperty('--reveal-delay', `${(index % 3) * 55}ms`);
      if (element.getBoundingClientRect().top > window.innerHeight) {
        element.classList.add('mm-reveal-pending');
        observer.observe(element);
      }
    });
  }
  configureMotion();
  on(preference, 'change', configureMotion);
  
  on(document, 'focusin', event => event.target.closest('.mm-reveal-pending')?.classList.remove('mm-reveal-pending'));
  const galleryImage = document.getElementById('main-photo');
  on(galleryImage, 'load', () => {
    if (preference.matches) return;
    galleryImage.getAnimations().forEach(animation => animation.cancel());
    galleryImage.animate([{ opacity: .3, transform: 'scale(1.015)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
  });
  const form = document.getElementById('book-configurator');
  on(form, 'change', event => {
    if (preference.matches || event.target.type !== 'radio') return;
    const selected = event.target.nextElementSibling;
    selected?.animate([{ transform: 'scale(.97)' }, { transform: 'scale(1)' }], { duration: 220, easing: 'ease-out' });
  });

  const moment = document.getElementById('motion-story');
  const bookStage = moment?.querySelector('.mm-book-stage');
  const play = document.getElementById('mm-play-book');
  const toggle = document.querySelector('.mm-motion-toggle');
  const coverArt = moment?.querySelector('.mm-cover-art');
  function fitCoverArt() {
    if (!coverArt) return;
    const width = coverArt.clientWidth;
    const height = coverArt.clientHeight;
    if (!width || !height) return;
    const source = [[585,153],[771,291],[629,646],[456,503]];
    const target = [[0,0],[width,0],[width,height],[0,height]];
    const equations = [];
    source.forEach(([x,y], i) => {
      const [u,v] = target[i];
      equations.push([x,y,1,0,0,0,-u*x,-u*y,u]);
      equations.push([0,0,0,x,y,1,-v*x,-v*y,v]);
    });
    for (let column = 0; column < 8; column++) {
      let pivot = column;
      for (let row = column + 1; row < 8; row++) {
        if (Math.abs(equations[row][column]) > Math.abs(equations[pivot][column])) pivot = row;
      }
      [equations[column], equations[pivot]] = [equations[pivot], equations[column]];
      const divisor = equations[column][column];
      if (Math.abs(divisor) < 1e-10) return;
      equations[column] = equations[column].map(value => value / divisor);
      for (let row = 0; row < 8; row++) {
        if (row === column) continue;
        const factor = equations[row][column];
        equations[row] = equations[row].map((value, i) => value - factor * equations[column][i]);
      }
    }
    const [a,b,c,d,e,f,g,h] = equations.map(row => row[8]);
    coverArt.querySelector('img').style.transform = `matrix3d(${a},${d},0,${g},${b},${e},0,${h},0,0,1,0,${c},${f},0,1)`;
  }
  if (coverArt) {
    fitCoverArt();
    if ('ResizeObserver' in window) { const resizeObserver = new ResizeObserver(fitCoverArt); resizeObserver.observe(coverArt); cleanup(() => resizeObserver.disconnect()); }
    else on(window, 'resize', fitCoverArt);
  }
  let paused = false;
  let frame = 0;
  let playing = false;
  let scrollFrame = 0;
  function setOpening(progress) {
    if (!moment) return;
    moment.style.setProperty('--book-angle', `${-180 * progress}deg`);
    moment.style.setProperty('--book-offset', `${-25 * (1 - progress)}%`);
    moment.style.setProperty('--hinge-shadow', String(Math.sin(progress * Math.PI) * .28));
    moment.style.setProperty('--cover-shade', String(Math.sin(progress * Math.PI) * .16));
  }
  function scrollOpening() {
    scrollFrame = 0;
    if (!moment || playing || paused || preference.matches) return;
    const rect = bookStage.getBoundingClientRect();
    const start = window.innerHeight * .92 - rect.height;
    const distance = Math.max(80, start - window.innerHeight * .12);
    const progress = Math.max(0, Math.min(1, (start - rect.top) / distance));
    setOpening(progress * progress * (3 - 2 * progress));
  }
  function stopOpening() {
    cancelAnimationFrame(frame);
    playing = false;
    if (play) play.querySelector('[data-mm-motion-label]').textContent = 'Replay the opening';
  }
  function updateMotionPreference() {
    stopOpening();
    if (preference.matches) {
      setOpening(1);
      if (play) { play.disabled = true; play.querySelector('[data-mm-motion-label]').textContent = 'Reduced motion enabled'; }
    } else {
      if (play) { play.disabled = false; play.querySelector('[data-mm-motion-label]').textContent = 'Play the opening'; }
      scrollOpening();
    }
  }
  if (moment) {
    updateMotionPreference();
    on(preference, 'change', updateMotionPreference);
    on(window, 'scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(scrollOpening); }, {passive:true});
    on(window, 'resize', scrollOpening, {passive:true});
    on(play, 'click', () => {
      if (preference.matches) return;
      if (playing) { stopOpening(); return; }
      paused = false;
      document.documentElement.classList.remove('mm-motion-paused');
      toggle?.setAttribute('aria-pressed', 'false');
      if (toggle) toggle.textContent = 'Pause motion Ⅱ';
      playing = true;
      play.querySelector('[data-mm-motion-label]').textContent = 'Pause the opening';
      setOpening(0);
      const start = performance.now();
      function tick(now) {
        const progress = Math.max(0, Math.min(1, (now - start - 550) / 4400));
        const eased = progress * progress * (3 - 2 * progress);
        setOpening(eased);
        if (progress < 1) frame = requestAnimationFrame(tick);
        else stopOpening();
      }
      frame = requestAnimationFrame(tick);
    });
  }
  on(toggle, 'click', () => {
    paused = !paused;
    document.documentElement.classList.toggle('mm-motion-paused', paused);
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.textContent = paused ? 'Resume motion ▷' : 'Pause motion Ⅱ';
    if (paused) stopOpening(); else scrollOpening();
  });
  on(document, 'visibilitychange', () => { if (document.hidden) stopOpening(); });

cleanup(() => { observer?.disconnect(); cancelAnimationFrame(frame); cancelAnimationFrame(scrollFrame); });
});
